var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageIsLoading)?_c('v-progress-circular',{staticClass:"ml-4",attrs:{"indeterminate":"","color":"primary"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }